import React from "react";
import LinkCommonComponent from "../common/LinkCommonComponent";
import { clientAddNewRequirement } from "../../desktop/common/allLinks";

export default function ClientDashboardNewRequirementsFirstTime() {
  const renderTitle = (text) => {
    return <h2 className="font-48-NunitoSans-600 mb-10">{text}</h2>;
  };

  return (
    <div className="row mx-0 align-items-center justify-content-center mt-agency-dashboard-first-time-block">
      <div className="mt-agency-dashboard-first-time-block__content">
        <>
          {renderTitle("Welcome !")}
          <p className="font-24-NunitoSans-600 color-white-66 mb-10">
            You currently have no requirements active
          </p>
          <p className="font-24-NunitoSans-600 mb-25">
            Lets start by posting one!
          </p>
          <LinkCommonComponent
            extraClassName="mb-25"
            linkText="Start"
            linkPath={clientAddNewRequirement}
          />
        </>
      </div>
    </div>
  );
}
